module.exports = __webpack_public_path__ + "static/media/persona4.4ef894f3.png";